const topics = [
  { label: '最新高清电影', hot: true },
  { label: '电视剧高清全集', hot: true },
  { label: '流畅不卡顿', hot: true },
  { label: '动作大片', hot: false },
  { label: '悬疑烧脑', hot: false },
  { label: '高分推荐', hot: true },
  { label: '喜剧合集', hot: false },
  { label: '科幻巨制', hot: false },
  { label: '经典重温', hot: false },
  { label: '周末观影', hot: true },
  { label: '热播新剧', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              大家都在关注的高清影视话题，找到你的兴趣圈子
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
            {topics.map((topic, i) => (
              <span
                key={i}
                className={`inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  topic.hot
                    ? 'bg-accent-100 text-accent-700 border border-accent-200/50 hover:bg-accent-200/70'
                    : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-accent-300/40 hover:text-accent-600'
                }`}
              >
                {topic.label}
                {topic.hot && (
                  <i className="ri-fire-line text-xs text-accent-500"></i>
                )}
              </span>
            ))}
          </div>

          <div className="mt-8 md:mt-10 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 text-center">
            <p className="text-sm text-foreground-500">
              实时热门搜索：<strong className="text-accent-600 font-semibold">高清电影在线</strong> · <strong className="text-accent-600 font-semibold">蘑菇影院高清</strong> · <strong className="text-accent-600 font-semibold">流畅不卡顿</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}